import React, { useState } from 'react';
import { newPost } from '../../firebase/writeData';
import {firebase} from "../../firebase/firebaseConfig";

import {Modal, Form, Button, ButtonGroup, Col, Row} from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

export default function Post(props) {
  const [summary, setSummary] = useState('');
  const [city, setCity] = useState('');
  const [region, setRegion] = useState('');
  const [country, setCountry] = useState([]);
  const [sector, setSector] = useState([]);
  const [features, setFeatures] = useState([]);
  const [description, setDescription] = useState('');
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState({});

  const cleanup = () => {
    setSummary('');
    setCity('');
    setRegion('');
    setCountry([]);
    setSector([]);
    setFeatures([]);
    setDescription('');
    setValidated(false);
    setErrors({});
    props.setOpen(false);
  }

  const updateSummary = (e) => {
    const newSummary = e.target.value;
    if (newSummary.length <= 150) setSummary(newSummary);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};

    if (!summary) errors.summary = true;
    if (city.length === 0) errors.city = true;
    if (region.length === 0) errors.region = true;
    if (country.length === 0) errors.country = true;
    if (sector.length === 0) errors.sector = true;
    if (features.length === 0) errors.features = true;
    if (Object.keys(errors).length === 0) {
      setValidated(true);

      let newFeatures = [];
      features.forEach(feat => {
        if (typeof feat !== 'string') newFeatures.push(feat.features);
        else newFeatures.push(feat)
      })

      //Firebase stuff
      newPost(city, region, country, summary, description, newFeatures, sector)
      cleanup()
    } else {
      let invalid = [];
      Object.keys(errors).forEach((err) => {
        if (errors[err]) invalid.push(err);
      })
      firebase.analytics().logEvent('invalid_post_attempt', {invalid});
      e.stopPropagation();
      setErrors(errors);
      setValidated(false);
    }
  }

  return (
    <div>
      <Modal
      show={props.show}
      size="lg"
      onHide={() => props.setOpen(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Share your idea
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="font-weight-bold">Summarise your idea ({summary.length + '/150'})</Form.Label>
              <Form.Control 
                required 
                type="text"
                isInvalid={errors.summary}
                placeholder="Ex. A delivery service for zero-waste groceries..." 
                value={summary} 
                onChange={updateSummary}
                />
              <Form.Control.Feedback type="invalid">
                Oops! Did you miss filling this out? 
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formRegion" className="mt-4">
              <Form.Label className="font-weight-bold">Where is this needed?</Form.Label>

              <Row>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Text className="text-muted">City</Form.Text>
                  <Form.Control 
                    required 
                    type="text" 
                    isInvalid={errors.city}
                    placeholder="Ex. Denver..." 
                    value={city} 
                    onChange={(e) => setCity(e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Hmmm... this doesn't seem right. 
                    </Form.Control.Feedback>
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridRegion">
                  <Form.Text className="text-muted">Region</Form.Text>
                  <Form.Control 
                    required 
                    type="text" 
                    placeholder="Ex. Colorado..." 
                    value={region} 
                    isInvalid={errors.region}
                    onChange={(e) => setRegion(e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Try double-checking this?  
                    </Form.Control.Feedback>
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridCountry">
                  <Form.Text className="text-muted">Country</Form.Text>
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="country"
                      onChange={setCountry}
                      options={countries}
                      placeholder="CLICK on a country..."
                      selected={country}
                    />
                    {errors.country && (<p className="errorText">Make sure to CLICK on a suggestion</p>)}
                </Form.Group>
                </Col>

              </Row>
            </Form.Group>

            <Form.Group controlId="formTags" className="mt-4">
              <Form.Label className="font-weight-bold">Tag some industries and features!</Form.Label>

              <Row>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridIndustries">
                  <Form.Text className="text-muted">Industry</Form.Text>
                  <Typeahead
                    id="basic-typeahead-single"
                    labelKey="industry"
                    onChange={setSector}
                    options={industries}
                    placeholder="CLICK on industries..."
                    selected={sector}
                    multiple
                  />
                  {errors.sector && (<p className="errorText">Make sure to CLICK on a suggestion</p>)}
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridFeatures">
                  <Form.Text className="text-muted">Features</Form.Text>
                  <Typeahead
                    id="basic-typeahead-single"
                    labelKey="features"
                    onChange={setFeatures}
                    options={availableFeatures}
                    placeholder="CLICK on features..."
                    selected={features}
                    multiple
                    allowNew
                  />
                  {errors.features && (<p className="errorText">Make sure to CLICK on a suggestion</p>)}
                </Form.Group>
                </Col>

              </Row>
            </Form.Group>

            <Form.Group controlId="formTextArea" className="mt-4">
              <Form.Label className="font-weight-bold">Any other details?</Form.Label>
              <Form.Control 
                as="textarea" 
                rows={3} 
                placeholder="How did you get this idea? Have you found anything similar?"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                />
            </Form.Group>

            <ButtonGroup className="d-flex mt-5">
              <Button block variant="success" onClick={handleSubmit}>Submit</Button>
            </ButtonGroup>
      
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

const countries = ["United States", "Canada", "Afghanistan","Argentina","Australia","Austria","Bangladesh","Belgium","Brazil","British Virgin Islands","Bulgaria","Chile","China","Colombia","Costa Rica","Cuba","Czech Republic","Denmark","Dominican Republic","Ecuador","Egypt","Estonia","Ethiopia","Finland","France","Germany","Greece","Greenland","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Kenya","Laos","Latvia","Lithuania","Luxembourg","Malaysia","Mexico","Morocco","Nepal","Netherlands","New Zealand","Nigeria","Norway","Pakistan","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Romania","Russia","Rwanda","Saudi Arabia","Serbia","Singapore","South Africa","South Korea","Spain","Sri Lanka","Sweden","Switzerland","Syria","Taiwan","Tanzania","Thailand","Turkey","Uganda","Ukraine","United Arab Emirates","United Kingdom", "Venezuela","Vietnam","Virgin Islands"];
const industries = ["Retail", "Fashion", "Restaurant", "Ecommerce", "Food", "Services", "Household", "Health/Beauty", "Technology"];
const availableFeatures = ["Local", "Organic", "Low/No Waste", "Sustainable Sourcing", "Meat-free", "Reusable", "Low Emissions"];